module.exports = __webpack_public_path__ + "static/media/PetInTimeFrame2.d40f42c9.png";